import { useRef } from 'react';
import { useTheme } from '../../context/ThemeContext.jsx';

export default function UploadZone({ uploading, uploadProgress, uploadError, dragOver, setDragOver, onDrop, onFiles }) {
  const { theme } = useTheme();
  const fileInputRef = useRef(null);
  const folderInputRef = useRef(null);

  return (
    <div
      onDragOver={e => { e.preventDefault(); setDragOver(true); }}
      onDragLeave={() => setDragOver(false)}
      onDrop={onDrop}
      onClick={() => fileInputRef.current?.click()}
      style={{
        margin: '16px 24px 0', padding: 28,
        border: `1px dashed ${theme.accent}`,
        borderRadius: 0,
        background: dragOver ? theme.accentBg : 'transparent',
        textAlign: 'center', cursor: 'pointer', transition: 'background 0.2s',
      }}
    >
      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept=".otf,.ttf,.woff,.woff2,.txt,.pdf,.html,.htm,.rtf,.md"
        onChange={e => onFiles(e.target.files)}
        style={{ display: 'none' }}
      />
      <input
        ref={folderInputRef}
        type="file"
        webkitdirectory=""
        multiple
        onChange={e => onFiles(e.target.files)}
        style={{ display: 'none' }}
      />
      {uploading ? (
        <>
          <div style={{ fontSize: 13, fontWeight: 600, color: theme.accent }}>
            Uploading {uploadProgress?.current}/{uploadProgress?.total} files...
          </div>
          <div style={{
            width: 200, height: 4, background: theme.bgInput,
            borderRadius: 0, margin: '12px auto 0', overflow: 'hidden',
          }}>
            <div style={{
              width: `${(uploadProgress?.current / uploadProgress?.total) * 100}%`,
              height: '100%', background: theme.accent, borderRadius: 0,
              transition: 'width 0.3s',
            }} />
          </div>
        </>
      ) : (
        <>
          <div style={{ fontSize: 15, color: theme.text, marginBottom: 6 }}>
            drop files or a folder here
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 12 }}>
            <button
              onClick={e => { e.stopPropagation(); fileInputRef.current?.click(); }}
              style={{
                height: 32, background: 'none', display: 'inline-flex', alignItems: 'center', padding: '0 14px',
                border: `1px solid ${theme.borderMedium}`, color: theme.textSecondary,
                fontSize: 12, textTransform: 'lowercase', cursor: 'pointer', fontFamily: 'inherit',
              }}
            >browse files</button>
            <button
              onClick={e => { e.stopPropagation(); folderInputRef.current?.click(); }}
              style={{
                height: 32, background: 'none', display: 'inline-flex', alignItems: 'center', padding: '0 14px',
                border: `1px solid ${theme.borderMedium}`, color: theme.textSecondary,
                fontSize: 12, textTransform: 'lowercase', cursor: 'pointer', fontFamily: 'inherit',
              }}
            >browse folder</button>
          </div>
          <div style={{ fontSize: 11, letterSpacing: '0.05em', textTransform: 'uppercase', color: theme.textFaint, marginTop: 14 }}>
            .otf .ttf .woff .woff2 · license files included automatically
          </div>
        </>
      )}
      {uploadError && (
        <div style={{ color: theme.red, fontSize: 12, marginTop: 8 }}>{uploadError}</div>
      )}
    </div>
  );
}
